import {Button, Textarea} from '@mantine/core';
import React, {useEffect, useRef, useState} from 'react';

import {signal} from "@preact/signals-react";
import {useSignals} from '@preact/signals-react/runtime';
import {useIsMobile} from '@/utils/user_agent';

type CommentFormProps = {
    onSubmit: (text: string) => Promise<void>;
    initialValue?: string;
    onCancel?: () => void;
    isReply?: boolean;
    onInitialFocus?: () => string;
    newTimestamp?: {timestamp: string} | null;
    scrollIntoView?: {scrollIntoView: boolean};
};

export const signalCommentTextareaIsFocused = signal(false);

export const CommentForm = (props: CommentFormProps) => {
    useSignals();

    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const [draft, setDraft] = useState(props.initialValue || '');

    const submitButtonText = props.isReply ? 'Add Reply' : 'Submit';

    const isMobile = useIsMobile();

    useEffect(() => {
        if (props.scrollIntoView && !isMobile) {
            setTimeout(() => {
                window.scrollBy({ top: (textareaRef?.current?.getBoundingClientRect().top || 0) - 400, behavior: 'smooth' });
                textareaRef.current?.focus();
            }, 100);
        }
    }, [props.scrollIntoView]);

    const handleTextareaClick = (event: React.MouseEvent) => {
        event.preventDefault();

        document.querySelector('main')!.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        if (props.newTimestamp) {
            setDraft(`${draft ? `${draft}\n` : ''}${props.newTimestamp.timestamp} `);
            textareaRef.current?.focus();
        }
    }, [props.newTimestamp]);

    return (
        <form
            id='comment-form'
            // reply={props.isReply}
            onSubmit={async (e) => {
                e.preventDefault();
                await props.onSubmit(draft);
                setDraft('');
            }}
        >
            <Textarea
                ref={textareaRef}
                id='comment-textarea'
                style={{
                    maxWidth: '600px',
                }}
                onClick={handleTextareaClick}
                className='comment-textarea-container'
                value={draft}
                onChange={e => {
                    e.stopPropagation();

                    setDraft(e.target.value);
                }}
                autosize={true}
                minRows={5}
                onFocus={async () => {
                    signalCommentTextareaIsFocused.value = true;

                    // if (!draft && props.onInitialFocus) {
                    //     const result = props.onInitialFocus();
                    //     if (result) {
                    //         setDraft(result);
                    //     }
                    // }
                }}
                onBlur={() => {
                    setTimeout(() => {
                        signalCommentTextareaIsFocused.value = false;
                    }, 500);
                }}
            />

            <div style={{height: '10px'}} />

            <div>
                <Button
                    className='comment-submit-button'
                    type='submit'
                    disabled={!draft.length}
                >
                    {submitButtonText}
                </Button>
                {props.onCancel && (
                    <Button
                        variant='subtle'
                        type='button'
                        onClick={props.onCancel}
                        style={{marginLeft: '5px'}}
                    >
                        Cancel
                    </Button>
                )}
            </div>

            <div style={{height: '20px'}} />
        </form>
    );
};
